const tableCellVerification = {
  Typography: 'Do you really want to delete this item?',
  editSwitchYes: 'Yes',
  editSwitchNo: 'No'
};

export default tableCellVerification;
